export default __webpack_public_path__ + "static/media/Group160.d2b6431d.png";